import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  label:
    ([color, _]: [string, string]) =>
    (theme: Theme) => ({
      borderLeft: `0.25rem solid ${color}`,
      color: theme.colors.neutral[900],
      justifyContent: 'center',
      pl: 0.5,
      pr: 1.5,
    }),

  filterSelect: muiSelectStyles.filterSelect,

  filterPaper: { ...muiSelectStyles.filterPaper, maxHeight: '11.25rem' },

  filterMenuItem: muiSelectStyles.filterMenuItem,
};
